module.exports = __webpack_public_path__ + "static/media/chaliceWrong.044638b4.png";